import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'
import Moment from 'moment'
import { Link } from 'react-router'

import PageTitle from './PageTitle'

function showDate(dateString) {
  return Moment(dateString).format('MMMM, DD YYYY')
}

const List = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="portlet light portlet-fit">
          <div className="portlet-title">
            <div className="caption">
              <span className="caption-subject sbold uppercase">
                Invoice List
              </span>
            </div>
            <div className="actions">
              {props.data.totalPages > 1 && (
                <ReactPaginate
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  breakLabel={<a href="">...</a>}
                  breakClassName={'break-me'}
                  pageCount={props.data.totalPages}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={2}
                  onPageChange={props.handlePageChange}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              )}
            </div>
          </div>
          <div className="portlet-body">
            <div className="table-scrollable table-scrollable-borderless">
              <table className="table table-hover table-light">
                <thead>
                  <tr className="uppercase">
                    <th> # </th>
                    <th> Created at </th>
                    <th> Invoice Number </th>

                    <th> Project Name </th>
                    <th> Profile ID </th>
                    <th> Due Date </th>

                    <th> Expired Date </th>
                    <th> DeadLine Date </th>
                    <th> Invoice Type </th>
                    <th> SubTotal </th>
                    <th className="table-actions"> Actions </th>
                  </tr>
                </thead>
                <tbody>
                  { props.invoiceList.map((row, key) => (
                    <tr key={row.id}>
                      <td> {key + 1} </td>
                      <td> {showDate(row.createdAt)}</td>
                      <td> {row.invoiceNumber}</td>
                      <td> {row.order.name}</td>
                      <td> {row.profile.profileId}</td>
                      <td> {showDate(row.dueDate)}</td>
                      <td> {showDate(row.expiredDate)}</td>
                      <td> {showDate(row.deadlineDate)}</td>
                      <td> {row.invoiceType}</td>
                      <td> {row.subTotal}</td>
                      <td>
                        <Link to={`/projects/${row.order.id}`} className="btn btn-icon-only red">
                          <i className="fa fa-eye" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)


List.defaultProps = {
  data: {
    totalPages: 1,
    rows: [],
    qs: {
      skip: 0,
    },
  },
  isLoading: false,
}

List.propTypes = {
  data: PropTypes.shape({
    totalPages: PropTypes.number.isRequired,
    rows: PropTypes.array.isRequired,
    qs: PropTypes.shape({
      skip: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  invoiceList: PropTypes.arrayOf(PropTypes.object).isRequired,
  handlePageChange: PropTypes.func.isRequired,
}

export default List
